import { Routes, mapToCanActivate } from '@angular/router';
import { LocationGuard } from '@next/core-lib/relationships';

import { ReportOverviewComponent } from './components/report-overview/report-overview.component';
import { ReportGuard } from './guards/report.guard';
import { ReportComponent } from './report.component';

export const reportRoutes: Routes = [
  {
    path: 'report',
    component: ReportComponent,
    canActivate: mapToCanActivate([LocationGuard, ReportGuard]),
    children: [
      {
        path: '',
        component: ReportOverviewComponent,
        canActivate: mapToCanActivate([LocationGuard, ReportGuard]),
        data: { name: 'report-overview' },
      },
    ],
  },
];
